import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useGroupes from "./hooks/useGroupes";

import GroupDrawer from "./components/GroupDrawer";
import GroupDetails from "./components/GroupDetails";
import GroupForm from "./components/GroupForm";
import GroupesGrid from "./components/GroupesGrid";
import GroupesHero from "./components/GroupesHero";
import GroupesStats from "./components/GroupesStats";
import GroupesToolbar from "./components/GroupesToolbar";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Groupes() {
  useScrollToTop();
  const {
    loading,
    saving,
    filters,
    setFilter,
    groupes,
    filteredGroupes,
    selectedGroup,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useGroupes();

  return (
    <div className="space-y-6">
      <GroupesHero
        loading={loading}
        total={groupes.length}
        activeCount={stats.active}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshGroupes}
      />

      <GroupesStats loading={loading} stats={stats} />

      <GroupesToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={groupes.length}
        filteredCount={filteredGroupes.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshGroupes}
      />

      <GroupesGrid
        loading={loading}
        groupes={filteredGroupes}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
      />

      <GroupDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        group={selectedGroup}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedGroup && (
          <GroupDetails
            group={selectedGroup}
            onEdit={() => actions.openEditDrawer(selectedGroup)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <GroupForm
            mode="create"
            saving={saving}
            onSubmit={actions.createGroup}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedGroup && (
          <GroupForm
            mode="edit"
            group={selectedGroup}
            saving={saving}
            onSubmit={actions.updateGroup}
            onClose={actions.closeDrawer}
          />
        )}
      </GroupDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}